import React, { Fragment } from "react";
import { ErrorMessage, Field } from "formik";
import { withNamespace } from "../../../../util/forms/with-namespace";
import { NEWSLETTER } from "./field-names";
const NewsletterAgreementForm = _ref => {
    let { namespace } = _ref;
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkbox-field text-left mb-4"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement(Field, {
        type: "checkbox",
        name: withNamespace(NEWSLETTER, namespace)
    }), /*#__PURE__*/ React.createElement("span", null, "Ja, ich m\xF6chte den Newsletter empfangen.")), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(NEWSLETTER, namespace),
        component: "div",
        className: "error-message"
    })));
};
export default NewsletterAgreementForm;
